define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/core/extendedPathService",
	"csi/heading/Expression"
], function(declare, _, {parsePathSteps}, Expression) {

	return declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: count max depth of paths
			var paths = ctx.view._getViewPaths(ctx);
			var max = 0;

			_.each(paths, function(p) {
				var steps = parsePathSteps(p);
				var n = steps.length;
				if (n > max) max = n;
			});

			return max;
		}
	});
});